module.exports = __webpack_public_path__ + "img/software7.87b3fb89.jpg";